export default __webpack_public_path__ + "25df206850de8c7e43dd2545ab234b7b.png";